export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class RedirectableError extends Error {
  constructor(message, redirectUrl) {
    super(message);
    this.name = 'RedirectableError';
    this.redirectUrl = redirectUrl;
  }
}

class ErrorWithMetaData extends Error {
  constructor(error) {
    super(error);
    this.message = error.message;
    try {
      error = JSON.parse(error.message);
    } catch (e) {
      // ignore
    }
    this.isBackendError = error.isBackendError || false;
    this.isOhswError = error.isOhswError || false;
    this.source = error.source || 'unknown';
    this.type = error.type || 'unknown';
  }
}

export class DegradedStateAttemptedError extends ErrorWithMetaData {
  constructor(error) {
    super(error);
    this.name = 'DegradedStateAttemptedError';
  }
}

export class FhirRequestError extends ErrorWithMetaData {
  constructor(error) {
    super(error);
    this.name = 'FhirRequestError';
  }
}

export class DegradedStateFailureError extends Error {
  constructor(error) {
    super(error);
    this.name = 'DegradedStateFailureError';
  }
}

export const testingExports = { ErrorWithMetaData };
